/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

  // Initiate Masonry grid on archive pages
  var $masonry = jQuery('#masonry-container').masonry({
    itemSelector: '#masonry-container .cell',
    transitionDuration: 0
  });
  // layout Masonry after each image loads
  $masonry.imagesLoaded().progress( function() {
    $masonry.masonry('layout');
  });


	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();


	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('.text-block iframe[src*="youtube.com"], .text-block iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

  jQuery('.video-modal').on('closeme.zf.reveal', function() {
    var ytIframe = jQuery(this).find('iframe');
  	var ytUrl = jQuery(ytIframe).attr('src');
  	var ytAutoplay = ytUrl + '&autoplay=1';
  	jQuery(ytIframe).attr('src', ytAutoplay);
  });

  jQuery('.video-modal').on('closed.zf.reveal', function() {
    var ytIframe = jQuery(this).find('iframe');
  	var ytUrl = jQuery(ytIframe).attr('src');
  	var ytNoAutoplay = ytUrl.replace('&autoplay=1', '');
  	jQuery(ytIframe).attr('src', ytNoAutoplay);
  });


  // Slideshows
  jQuery('.gallery-block.slideshow').slick({
    infinite: true,
    dots: false,
    prevArrow: '<button type="button" class="slick-prev"><span class="show-for-sr">Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="show-for-sr">Next/span></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false
        }
      }
    ]
  });

  jQuery('.gallery-block.carousel').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    prevArrow: '<button type="button" class="slick-prev"><span class="show-for-sr">Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="show-for-sr">Next/span></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false
        }
      }
    ]
  });

  jQuery('.collection-carousel').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          infinite: true,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 1001,
        settings: {

          infinite: false,
          settings: "unslick"
        }
      }
    ]
  }).on('setPosition', function (event, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });


  // Footer links
  jQuery('.footer--nav-group > p > a').on('click', function(e) {
      var browserWidth = jQuery(window).width();
      if (browserWidth < 768) {
          jQuery(this).closest('.footer--nav-group').toggleClass('expanded');
          return false;
      }
  });


  // AJAX Load More Archive Posts
  var $container = jQuery('#masonry-container');
  var $loader = jQuery('#more_posts');
  var cat = $loader.data('cat');
  var tag = $loader.data('tag');
  var keyword = $loader.data('keyword');
  var ppp = 30;
  var offset = 30;

  $loader.on( 'click', load_ajax_posts );

  function load_ajax_posts() {

  	if (!($loader.hasClass('post_loading_loader') || $loader.hasClass('post_no_more_posts'))) {

  		jQuery.ajax({
  			type: 'POST',
  			dataType: 'html',
  			url: ajax_posts.ajaxurl,
  			data: {
  				'cat': cat,
  				'tag': tag,
  				'keyword' : keyword,
  				'ppp': ppp,
  				'offset': offset,
  				'action': 'mytheme_more_post_ajax'
  			},
  			beforeSend : function () {
  				$loader.addClass('post_loading_loader').html('Loading...');
  			},
  			success: function (data) {
  				var $data = jQuery(data);
  				if ($data.length) {
  				  $container.append( $data ).masonry().masonry( 'appended' ,$data );
  				  $container.imagesLoaded().progress( function() {
    $container.masonry('layout');
  });
  				}
  				if ($data.length == ppp) {
  				  $loader.removeClass('post_loading_loader').html(ajax_posts.loadmore).blur();
  				} else {
  					$loader.removeClass('post_loading_loader').addClass('post_no_more_posts').html(ajax_posts.noposts).blur();
  				}
  			},
  			error : function (jqXHR, textStatus, errorThrown) {
  				$loader.html($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
  				console.log(jqXHR);
  			},
  			complete: function(){
        }
  		});
  	}
  	offset += ppp;
  	return false;
  }

  jQuery('.newsletter-signup .form-content form, #footer--newsletter form').submit(function(ev) {
    var form = jQuery(this);
    ev.preventDefault();
    var data = jQuery(form).serialize();
    jQuery(form).find('button[type=submit]').hide();
    jQuery(form).find('.throbber').removeClass('hide');


    jQuery.post({
      url: 'https://www.filson.com/finewsletter/newsletter/signup',
      dataType: 'json',
      data: data,
      success: function(response) {
        jQuery(form).find('.message-container').text(response.message);
        jQuery(form).find('button[type=submit]').show();
        jQuery(form).find('.throbber').addClass('hide');

      },
      error: function (xhr, status) {
        jQuery(form).find('.message-container').text('Sorry, there was an error submitting the form');
        jQuery(form).find('button[type=submit]').show();
        jQuery(form).find('.throbber').addClass('hide');
      }
    })

  })


});